// use for create and edit locations storePhoto & businessHours
const transformBusinessHours = (data) => {
    const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return daysOfWeek.map(day => {
        const resp = {
            week_day: day,
            open: data[`businessHours_${day}_open`],
            open_time: data[`businessHours_${day}_open_time`],
            close_time: data[`businessHours_${day}_close_time`],
        };
        delete data[`businessHours_${day}_open`];
        delete data[`businessHours_${day}_open_time`];
        delete data[`businessHours_${day}_close_time`];
        return resp;
    });

};

const locationProvider = requestHandler => (type, resource, params) => {
    if ((type === 'CREATE' || type === 'UPDATE') && resource === 'locations') {
        console.log("locationProvider::", type, resource, params);

        if (params.data) {
            params.data.businessHours = transformBusinessHours(params.data);
        }
    }

    return requestHandler(type, resource, params);
}

export default locationProvider;